<template>
  <div id="app">
    <Dashboard />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Dashboard from './components/Dashboard.vue'

export default {
    name: 'App',
    components: {
        Dashboard
    },
    created() {
        this.setWindowSizeToStore(window)
        window.addEventListener("resize", this.windowHasBeenResized);
    },
    destroyed() {
        window.removeEventListener("resize", this.windowHasBeenResized);
    },
    methods: {
        windowHasBeenResized(e) {
            this.setWindowSizeToStore(e.target)
        },
        setWindowSizeToStore(window) {
            this.$store.dispatch('settings/setWindowWidth', window.innerWidth)
            this.$store.dispatch('settings/setWindowHeight', window.innerHeight)
        }
    }
}
</script>

<style>
  @import './assets/styles/global.css';
</style>